import { render } from "./Customer_Product_Modal.vue?vue&type=template&id=5e2a2336"
import script from "./Customer_Product_Modal.vue?vue&type=script&lang=js"
export * from "./Customer_Product_Modal.vue?vue&type=script&lang=js"

import "./Customer_Product_Modal.vue?vue&type=style&index=0&id=5e2a2336&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__